import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ifProp } from '@lib/ifProp';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

interface ButtonRectangularProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  isSolid?: boolean;
  text: string;
}

export const ButtonRectangular: React.FC<ButtonRectangularProps> = ({
  text,
  href,
  isSolid,
  className,
  onClick,
  target,
  rel,
}) => {
  return (
    <Button className={className} solid={isSolid} href={href} onClick={onClick} target={target} rel={rel}>
      {text}
    </Button>
  );
};

interface ButtonBaseProps {
  solid?: boolean;
}

const Button = styled.a<ButtonBaseProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 32px;
  min-width: 258px;

  font-family: var(--font-family-graphik);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 119%;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-decoration: none;

  ${ifProp(
    'solid',
    css`
      border: none;
      background-color: var(--colors-green);
      color: var(--colors-red);
      transition: background-color var(--duration-base) linear;

      &:hover {
        background-color: var(--colors-white-100);
      }
    `,
    css`
      border: 1px solid var(--colors-white-100);
      background-color: transparent;
      color: var(--colors-white-100);
      transition: border-color var(--duration-base) linear, color var(--duration-base) linear;

      &:hover {
        border-color: var(--colors-green);
        color: var(--colors-red);
      }
    `,
  )}

  ${getMediaqueryStyled('lg')} {
    padding: 12px 18px;
    min-width: 144px;
    font-size: 9px;
    line-height: 122%;
  }

  ${getMediaqueryStyled('md')} {
    padding: 16px 35px;
    min-width: 213px;
    font-size: 12px;
    line-height: 117%;
  }
`;
